// src/api/horariosAtendimento.js
import api from './api.js';
import { resolverEstabelecimentoAtivoId } from "../utils/estabelecimentoContext";

const horariosAtendimento = {
  listar: async (estabelecimentoId) => {
    try {
      const id = resolverEstabelecimentoAtivoId(estabelecimentoId);
      const response = await api.get(
        `/horarios-atendimento/estabelecimento/${id}/horarios`
      );
      return response.data;
    } catch (erro) {
      throw erro.response?.data || erro;
    }
  },

  listarPorDia: async (estabelecimentoId, dia) => {
    try {
      const id = resolverEstabelecimentoAtivoId(estabelecimentoId);
      const response = await api.get(
        `/horarios-atendimento/estabelecimento/${id}/horarios/${dia}`
      );
      return response.data;
    } catch (erro) {
      throw erro.response?.data || erro;
    }
  },

  // Lista horários disponíveis por data (YYYY-MM-DD) e opcionalmente por profissional
  listarDisponiveisPorData: async (
    estabelecimentoId,
    data,
    profissionalId,
    agendamentoId,
    servicoId
  ) => {
    try {
      const id = resolverEstabelecimentoAtivoId(estabelecimentoId);
      const params = new URLSearchParams();
      if (data) params.set('data', data);
      if (profissionalId) params.set('profissional_id', String(profissionalId));
      if (agendamentoId) params.set('agendamento_id', String(agendamentoId));
      if (servicoId) params.set('servico_id', String(servicoId));

      const response = await api.get(
        `/horarios-atendimento/estabelecimento/${id}/horarios-disponiveis?${params.toString()}`
      );
      return response.data;
    } catch (erro) {
      throw erro.response?.data || erro;
    }
  },

  adicionar: async (estabelecimentoId, dados) => {
    try {
      const id = resolverEstabelecimentoAtivoId(estabelecimentoId);
      const response = await api.post(
        `/horarios-atendimento/estabelecimento/${id}/horarios`,
        dados
      );
      return response.data;
    } catch (erro) {
      throw erro.response?.data || erro;
    }
  },

  adicionarLote: async (estabelecimentoId, horarios) => {
    try {
      const id = resolverEstabelecimentoAtivoId(estabelecimentoId);
      const response = await api.post(
        `/horarios-atendimento/estabelecimento/${id}/horarios/lote`,
        { horarios }
      );
      return response.data;
    } catch (erro) {
      throw erro.response?.data || erro;
    }
  },

  atualizar: async (estabelecimentoId, horarioId, dados) => {
    try {
      const id = resolverEstabelecimentoAtivoId(estabelecimentoId);
      const response = await api.put(
        `/horarios-atendimento/estabelecimento/${id}/horarios/${horarioId}`,
        dados
      );
      return response.data;
    } catch (erro) {
      throw erro.response?.data || erro;
    }
  },

  remover: async (estabelecimentoId, horarioId) => {
    try {
      const id = resolverEstabelecimentoAtivoId(estabelecimentoId);
      const response = await api.delete(
        `/horarios-atendimento/estabelecimento/${id}/horarios/${horarioId}`
      );
      return response.data;
    } catch (erro) {
      throw erro.response?.data || erro;
    }
  },

  // Alterna o status ativo de um horário
  alterarStatus: async (estabelecimentoId, horarioId, ativo) => {
    return horariosAtendimento.atualizar(estabelecimentoId, horarioId, { ativo });
  },

  removerVarios: async (estabelecimentoId, horarioIds = []) => {
    const ids = [...new Set((horarioIds || []).filter(Boolean))];
    if (!ids.length) return { total: 0 };

    const resultados = await Promise.allSettled(
      ids.map((horarioId) =>
        horariosAtendimento.remover(estabelecimentoId, horarioId)
      )
    );

    const total = resultados.filter(
      (resultado) => resultado.status === "fulfilled"
    ).length;

    return { total, erros: ids.length - total };
  },

  alterarStatusVarios: async (estabelecimentoId, alteracoes = []) => {
    const lista = (alteracoes || []).filter((item) => item?.id != null);
    if (!lista.length) return { total: 0 };

    const resultados = await Promise.allSettled(
      lista.map(({ id, ativo }) =>
        horariosAtendimento.alterarStatus(estabelecimentoId, id, ativo)
      )
    );

    const total = resultados.filter(
      (resultado) => resultado.status === "fulfilled"
    ).length;

    return { total, erros: lista.length - total };
  },
};

export default horariosAtendimento;
